export default __webpack_public_path__ + "static/media/spinner-big.4fc42f8e.png";